/**
 * @desc Displays a randomly chosen loading message
 * @example <cs-rotating-loading-msg></cs-rotating-loading-msg>
 */
;(function () {
  'use strict'

  angular
    .module('contrast.loading')
    .directive('csRotatingLoadingMsg', [csRotatingLoadingMsg])

  function csRotatingLoadingMsg() {
    return {
      replace: true,
      restrict: 'E',
      controller: 'csRotatingLoadingMsgCtrl',
      controllerAs: 'csRotatingLoadingMsgCtrl',
      templateUrl: 'views/cs-rotating-loading-msg.html'
    }
  }
})()
